module.exports = __webpack_public_path__ + "img/card.3076f3ba.svg";